export const orgUnit = {
  title: 'Org Units',
  loading: 'Loading org units...',
  error: 'Failed to load org units.',
  empty: 'No org units.',
  companyFallback: 'Company',
  tabs: {
    chart: 'Chart',
    list: 'List',
  },
  columns: {
    name: 'Name',
    path: 'Path',
  },
  zoom: {
    out: 'Zoom out',
    in: 'Zoom in',
    reset: 'Reset zoom',
  },
  chart: {
    noMembers: 'No one assigned',
  },
};

export type OrgUnitResources = typeof orgUnit;
